<script setup>
import { FormKit } from '@formkit/vue'

const { $auth } = useNuxtApp()
const emailInput = ref(null)
const email = ref(null)
const theme = ref(
  Object.assign(
    {
      emailCheck: {
        submitButton: {
          classes: '',
          label: 'Continue',
        },
      },
    },
    $auth.authModalTheme,
  ),
)

const submitEmailCheck = () => {
  $auth.checkUserExists(email.value)
}

onMounted(() => {
  emailInput.value.$el.querySelector('input').focus()
})
</script>

<template>
  <FormKit
    type="form"
    :actions="false"
    name="check_email"
    @submit="submitEmailCheck"
  >
    <slot name="title">
      <h4>Welcome</h4>
    </slot>
    <p>Please Enter Your Email to Continue</p>
    <FormKit
      ref="emailInput"
      type="text"
      name="email"
      label="Email address"
      validation="bail|required|email"
      :value="email"
      @input="($event) => (email = String($event).trim())"
    />
    <ErrorList :errors="$auth.checkUserExistsError" />
    <FormKit
      type="submit"
      :label="theme.emailCheck.submitButton.label"
      :input-class="theme.emailCheck.submitButton.classes"
    />
  </FormKit>
</template>
